import { atom } from "jotai";
import { Workbook, DataCache } from "../core/Workbook";
import { emptyWorkbook } from "../logic/new";
import { refreshDataCache } from "../logic/refreshDataCache";

// Core atoms
export const dataCacheAtom = atom<DataCache>({});

export const rawWorkbookAtom = atom<Workbook>(emptyWorkbook());

export const isWorkbookDirtyAtom = atom(false);

export const workbookAtom = atom<
  Workbook,
  Workbook | ((arg: Workbook) => Workbook)
>(
  (get) => get(rawWorkbookAtom),
  (get, set, arg) => {
    let workbook: Workbook;
    if (typeof arg === "function") {
      workbook = arg(get(rawWorkbookAtom));
    } else {
      workbook = arg;
    }
    set(rawWorkbookAtom, workbook);
    set(dataCacheAtom, (dataCache) => refreshDataCache(dataCache, workbook));
    set(isWorkbookDirtyAtom, true);
  }
);
